/* tslint:disable */
/* eslint-disable */
/**
 * UPM-metsa-api
 * UPM Metsä API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EventType,
    EventTypeFromJSON,
    EventTypeFromJSONTyped,
    EventTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    batchId: string;
    /**
     * Id of user who added this entry
     * @type {string}
     * @memberof Event
     */
    userId?: string;
    /**
     * Time when the entry was added
     * @type {Date}
     * @memberof Event
     */
    startTime: Date;
    /**
     * Time when the entry was added
     * @type {Date}
     * @memberof Event
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    additionalInformation?: string;
    /**
     * Working time spent in minutes
     * @type {number}
     * @memberof Event
     */
    timeSpentMinutes?: number;
    /**
     * 
     * @type {EventType}
     * @memberof Event
     */
    type: EventType;
    /**
     * 
     * @type {object}
     * @memberof Event
     */
    data: object;
}

export function EventFromJSON(json: any): Event {
    return EventFromJSONTyped(json, false);
}

export function EventFromJSONTyped(json: any, ignoreDiscriminator: boolean): Event {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'batchId': json['batchId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'startTime': (new Date(json['startTime'])),
        'endTime': !exists(json, 'endTime') ? undefined : (new Date(json['endTime'])),
        'additionalInformation': !exists(json, 'additionalInformation') ? undefined : json['additionalInformation'],
        'timeSpentMinutes': !exists(json, 'timeSpentMinutes') ? undefined : json['timeSpentMinutes'],
        'type': EventTypeFromJSON(json['type']),
        'data': json['data'],
    };
}

export function EventToJSON(value?: Event | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'batchId': value.batchId,
        'userId': value.userId,
        'startTime': (value.startTime.toISOString()),
        'endTime': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'additionalInformation': value.additionalInformation,
        'timeSpentMinutes': value.timeSpentMinutes,
        'type': EventTypeToJSON(value.type),
        'data': value.data,
    };
}


